export const renderReviewCategory = (category) => {
  switch (category) {
    case 1:
      return "오배송/교차배송";
    case 2:
      return "문앞미배송";
    case 3:
      return "임의배송";
    case 4:
      return "불만";
    case 5:
      return "칭찬";
    case 6:
      return "만족";
    case 7:
      return "칭찬";
    default:
      return "";
  }
};
